import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'When should I go to urgent care vs an emergency room?',
      answer: 'Urgent care can provide care for mild symptoms such as fever, cough, vomiting or diarrhea and injuries such as a cut, sprains/strains or broken bones. If you are experiencing the onset of severe pain or symptoms such as difficulty breathing, chest, abdominal pain or stroke like symptoms go to the ER.'
    },
    {
      question: 'Are walk-ins available?',
      answer: 'Walk-ins are welcome at our urgent care clinics, depending on availability. Feel free to book an appointment while you are on your way. This may speed up the check-in process and secure an available time.'
    },
    {
      question: 'Can urgent care refill my medications?',
      answer: 'Yes they can. Depending upon the type of medication and the last time it was refilled, your clinicians will discuss options available for a refill, new medication or connecting you with a primary care provider.'
    },
    {
      question: 'What kinds of tests can urgent care perform with same day results?',
      answer: 'There are a variety of tests available such as flu, strep throat, and COVID. If you are experiencing pain with urination or STI symptoms the urgent can help with those as well. If additional testing is required or cannot be completed in-house, we will send samples to our partner labs and contact you promptly once results are available.'
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const OfficeForm = () => (
    <div style={{
      width: '100%',
      height: '800px',
      overflow: 'hidden',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
    }}>
      <iframe 
        title="Contact Us Form"
        src="https://forms.office.com/Pages/ResponsePage.aspx?id=JvDATR8xuEKPc9pWetuIA152HT8sfctLv5FtWjZ0GVVUMU9TTUE4RkhNNTBHUjEzVFFHWDEyWDczUS4u&embed=true&hideTitle=true" 
        frameBorder="0" 
        marginWidth="0" 
        marginHeight="0" 
        style={{ 
          border: 'none',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }} 
        allowFullScreen 
        webkitallowfullscreen 
        mozallowfullscreen 
        msallowfullscreen>
      </iframe>
    </div>
  );

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="faq-grid">
          {/* Left Column - FAQ */}
          <div className="faq-column">
            <div className="help-icon-circle mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-help-circle text-primary">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <path d="M12 17h.01"></path>
              </svg>
            </div>
            <h2>Frequently Asked Questions</h2>
            <p className="subtitle">
              Find answers to common questions about our urgent care services
            </p>
            
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div 
                  className={`faq-item ${activeIndex === index ? 'active' : ''}`} 
                  key={index}
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="faq-question">
                    {faq.question}
                    <span className="toggle-icon">
                      {activeIndex === index ? '−' : '+'}
                    </span>
                  </div>
                  {activeIndex === index && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="contact-column">
            <div className="contact-form-container">
              <h3>Still Have Questions?</h3>
              <p className="contact-subtitle">
                Send us a message and we'll get back to you soon!
              </p>
              
              <div className="office-form-container">
                <OfficeForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;